/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import { IReportScheduleData } from '../../components/common/ReportSchedule/types';
import { createAction } from '../../modules/app/createAction';
import {
    AUTOREPORT_ID_GET_META_FAILURE,
    AUTOREPORT_ID_GET_META_START,
    AUTOREPORT_ID_GET_META_SUCCESS,
    AUTOREPORT_ID_GET_TAB_META_FAILURE,
    AUTOREPORT_ID_GET_TAB_META_START,
    AUTOREPORT_ID_GET_TAB_META_SUCCESS,
    AUTOREPORT_ID_LOAD_FORMAT_META,
    AUTOREPORT_ID_LOAD_SCHEDULE_META,
    AUTOREPORT_ID_SAVE_TABLE,
    AUTOREPORT_ID_UPDATE_FORMAT,
    AUTOREPORT_ID_UPDATE_SCHEDULE,
} from './constants';
import {
    IAutoReportIdFormatFields,
    IAutoReportIdFormatMeta,
    IAutoReportIdGetTabMetaStartPayload,
    IAutoReportIdSaveTablePayload,
    IAutoReportIdScheduleMeta,
    TAutoReportIdGetMetaFailureAction,
    TAutoReportIdGetMetaStartAction,
    TAutoReportIdGetMetaSuccessAction,
    TAutoReportIdGetMetaSuccessPayload,
    TAutoReportIdGetTabMetaFailureAction,
    TAutoReportIdGetTabMetaStartAction,
    TAutoReportIdGetTabMetaSuccessAction,
    TAutoReportIdLoadFormatMetaAction,
    TAutoReportIdLoadScheduleMetaAction,
    TAutoReportIdPayload,
    TAutoReportIdSaveTableAction,
    TAutoReportIdUpdateFormatAction,
    TAutoReportIdUpdateScheduleAction,
} from './types';

/*
* -------------------------------------------
*          AUTOREPORT ID META
* -------------------------------------------
*/

export const autoReportIdGetMetaStartAction = (payload: TAutoReportIdPayload)
    : TAutoReportIdGetMetaStartAction =>
    createAction(AUTOREPORT_ID_GET_META_START, payload);

export const autoReportIdGetMetaSuccessAction = (payload: TAutoReportIdGetMetaSuccessPayload)
    : TAutoReportIdGetMetaSuccessAction =>
    createAction(AUTOREPORT_ID_GET_META_SUCCESS, payload);

export const autoReportIdGetMetaFailureAction = (payload: string)
    : TAutoReportIdGetMetaFailureAction =>
    createAction(AUTOREPORT_ID_GET_META_FAILURE, payload);


export const autoReportIdGetTabMetaStartAction = (payload: IAutoReportIdGetTabMetaStartPayload)
    : TAutoReportIdGetTabMetaStartAction =>
    createAction(AUTOREPORT_ID_GET_TAB_META_START, payload);

export const autoReportIdGetTabMetaSuccessAction = ()
    : TAutoReportIdGetTabMetaSuccessAction =>
    createAction(AUTOREPORT_ID_GET_TAB_META_SUCCESS);

export const autoReportIdGetTabMetaFailureAction = ()
    : TAutoReportIdGetTabMetaFailureAction =>
    createAction(AUTOREPORT_ID_GET_TAB_META_FAILURE);

/*
* -------------------------------------------
*          AUTOREPORT ID FORMAT META
* -------------------------------------------
*/

export const autoReportIdLoadFormatMetaAction = (payload: IAutoReportIdFormatMeta)
    : TAutoReportIdLoadFormatMetaAction =>
    createAction(AUTOREPORT_ID_LOAD_FORMAT_META, payload);


export const autoReportIdUpdateFormatAction = (payload: IAutoReportIdFormatFields)
    : TAutoReportIdUpdateFormatAction =>
    createAction(AUTOREPORT_ID_UPDATE_FORMAT, payload);

/*
* -------------------------------------------
*    AUTOREPORT ID SCHEDULE PARAMETERS
* -------------------------------------------
*/

export const autoReportIdLoadScheduleMetaAction = (payload: IAutoReportIdScheduleMeta)
    : TAutoReportIdLoadScheduleMetaAction =>
    createAction(AUTOREPORT_ID_LOAD_SCHEDULE_META, payload);

export const autoReportIdUpdateScheduleAction = (payload: IReportScheduleData)
    : TAutoReportIdUpdateScheduleAction =>
    createAction(AUTOREPORT_ID_UPDATE_SCHEDULE, payload);

/*
* -------------------------------------------
*    AUTOREPORT ID TABLE
* -------------------------------------------
*/

export const autoReportIdSaveTableAction = (payload: IAutoReportIdSaveTablePayload)
    : TAutoReportIdSaveTableAction =>
    createAction(AUTOREPORT_ID_SAVE_TABLE, payload);
